/** This pass IS the Online Club product — identity, not attendance mode. Requires passTypeId populated. */
export function isOnlineClubPass(pass) {
  return !!pass?.passTypeId?.onlineOnly;
}

/** Requires passTypeId populated (with the `trial` field). */
export function isTrialPass(pass) {
  return !!pass?.passTypeId?.trial;
}

/**
 * A pass is "individual" if every class type it's allowed to book is an individual one.
 * Requires passTypeId.allowedClassTypes populated with `isIndividual`.
 */
export function isIndividualPass(pass) {
  const types = pass?.passTypeId?.allowedClassTypes || pass?.allowedClassTypes || [];
  return types.length > 0 && types.every((ct) => (ct && typeof ct === "object" ? ct.isIndividual : ct) === true);
}
